import React from 'react'
import Input from '../../layout/Input'
import { Gender } from '../../../store/user/types'

type GenderSelectProps = {
  onChange: (e: Gender) => void
}

export const GenderSelect: React.FC<GenderSelectProps> = ({ onChange }) => {
  const [selectedGender, setSelectedGender] = React.useState<Gender | null>(null)

  const handleGenderSelect = (gender: Gender) => {
    setSelectedGender(gender)
    onChange(gender)
  }

  return (
    <Input
      name="gender"
      value={((selectedGender as unknown) as string) || ''}
      label="Geschlecht"
      type="select"
      onChange={gender => handleGenderSelect((gender as unknown) as Gender)}
    >
      <option value="1">Männlich</option>
      <option value="2">Weiblich</option>
      <option value="3">Divers</option>
    </Input>
  )
}
